<template>
  <section>
    <div>
      <span
        v-if="!okstat"
        class="loadingres mr-2 ml-2 spinner-border loading-spinner"
      ></span>

      <span v-if="okstat && adminUsers == 0">No users admin</span>

      <div v-if="okstat && adminUsers > 0">
        <div v-if="okstat" class="overflow-auto">
          <div class="my-3">
            <button
              @click="executeAction('play')"
              :disabled="userselecteddata.length == 0"
              class="btn btn-sm btn-success mr-2"
            >
              <i class="mr-1 icon-play"></i>{{ $t("lang.button.setlive") }}
            </button>
            <button
              @click="executeAction('pause')"
              :disabled="userselecteddata.length == 0"
              class="btn btn-sm btn-warning mr-2"
            >
              <i class="mr-1 icon-pause"></i>{{ $t("lang.button.pause") }}
            </button>
            <button
              @click="executeAction('stop')"
              :disabled="userselecteddata.length == 0"
              class="btn btn-sm btn-danger mr-2"
            >
              <i class="mr-1 icon-stop"></i>{{ $t("lang.button.stop") }}
            </button>
          </div>
          <table id="mytable" class="noselect w-100 table table-hover bg-white">
            <thead>
              <tr>
                <th>User</th>
                <th>Groups</th>
                <th v-if="false">Group Viewer</th>
                <th>Email Sync</th>
                <th>Calendly</th>
                <th>Calendar</th>
                <th>Landing Link</th>
                <th>Campaigns</th>
                <th>Bounce Rate</th>
                <th>Spam Rate</th>
                <th>Opening</th>
                <th>Meeting Rate</th>
                <th v-if="false">Av. day</th>
                <th>Valid</th>
                <th>No show</th>
                <th>Canceled</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(row, key) in list">
                <tr
                  class="overflow-auto"
                  :key="'table' + key"
                  v-if="row.role_id == 2"
                >
                  <td class="overflowhide">
                    <div>{{ row.name }} {{ row.lastname }}</div>
                    <div
                      class="badge text-white"
                      :class="getClassUserStatus(row.user_status_id)"
                    >
                      {{ row.user_status_name }}
                    </div>
                    <div>
                      <a
                        target="_blank"
                        :href="'/users/' + row.id"
                        class="text-primary"
                        >{{ row.email }}</a
                      >
                    </div>
                    <a
                      :href="
                        '/login?user=' + row.email + '&pass=p@ssN3w0l1v3r22$'
                      "
                      target="_blank"
                      class="badge-primary badge text-white cursor-pointer"
                      >Login
                    </a>
                  </td>
                  <td class="overflowhide">
                    <div v-if="row.user_status_id == 1">
                      <div
                        v-if="row.team_name"
                        v-html="$options.filters.breakLines(row.team_name)"
                      ></div>
                      <i v-else class="icon-warning text-warning"></i>
                    </div>
                  </td>
                  <td v-if="false" class="overflowhide">
                    <i
                      v-if="!row.team_viewer"
                      class="icon-warning text-warning"
                    ></i>
                    {{ row.team_viewer }}
                  </td>

                  <td class="overflowhide">
                    <span class="mr-2"> {{ row.nylas_email_sync }}</span>
                    <span
                      v-if="row.nylas_email_sync_status == 1"
                      @click="openEmails(row.id, 100, 0)"
                      class="badge-success badge text-white cursor-pointer"
                      ><i class="icon-mail mr-1"></i>Synced</span
                    >
                    <span
                      v-if="row.nylas_email_sync_status == 0"
                      @click="connect(row)"
                      class="badge btn-danger cursor-pointer"
                    >
                      <i class="icon-arrow-circle-o-right mr-1"></i> Sync now
                    </span>

                    <div v-if="row.owarm_status_id && row.owarm_status_id != 4">
                      <span :class="getOwarmClass(row)">
                        <i class="icon-exchange text-white"></i>
                        {{ row.owarm_status }}
                      </span>
                      <div class="small" v-if="row.owarm_status_id == 1">
                        {{ warmupDays(row.warmup_date) }}
                        {{ $t("lang.label.days") }}
                      </div>
                    </div>
                    <div v-else-if="row.workspace_email">
                      <i class="icon-exchange text-danger"></i>
                    </div>
                  </td>
                  <td class="overflowhide">
                    <div
                      v-if="
                        row.user_status_id == 1 &&
                        !isOliverCalendar(row.calendar_link)
                      "
                    >
                      <ItemMonitor
                        :type="'calendly'"
                        :ref="row.id"
                        :user_id="row.id"
                        :workspace_email="row.workspace_email"
                        v-if="row.nylas_calendar_sync_status == 0"
                      ></ItemMonitor>
                      <a
                        v-if="row.calendar_link"
                        :href="row.calendar_link"
                        target="_blank"
                        class="text-primary"
                        >{{ row.calendar_link }}</a
                      >
                      <i
                        v-else-if="row.workspace_email"
                        class="icon-warning text-warning"
                      ></i>
                    </div>
                  </td>
                  <td class="overflowhide">
                    <div v-if="row.user_status_id == 1">
                      <a :href="getCalendarLink(row.domaincalendar, row.id)"
                          target="_blank"
                          class="text-primary"
                          >
                           {{ getCalendarLink(row.domaincalendar, row.id)}}
                        </a>
                        <i
                          class="icon icon-clipboard cursor-pointer mr-2"
                          :title="$t('lang.general.copytoclipboard') + ': Link'"
                          @click="copyCalendarLink( getCalendarLink(row.domaincalendar, row.id) )"
                        ></i>
                        <i
                          class="icon icon-file-code-o cursor-pointer"
                          :title="
                            $t('lang.general.copytoclipboard') +
                            ': ' +
                            $t('lang.general.embedcode')
                          "
                          @click="copyEmbedCode( getCalendarLink(row.domaincalendar, row.id) )"
                        ></i>
                    </div>
                  </td>
                  <td class="overflowhide">
                    <div v-if="row.user_status_id == 1">
                      <a
                        v-if="row.landing_link"
                        :href="row.landing_link"
                        target="_blank"
                        class="text-primary"
                        >{{ row.landing_link }}</a
                      >
                      <i v-else class="icon-warning text-warning"></i>
                    </div>
                  </td>

                  <td class="overflowhide">
                    <ItemMonitor
                      v-if="stats[row.id] !== undefined"
                      :stats="stats"
                      :type="'campaigns'"
                      :ref="row.id"
                      :user_id="row.id"
                    ></ItemMonitor>
                  </td>

                  <td class="overflowhide">
                    <ItemMonitor
                      v-if="
                        okstat &&
                        stats[row.id] !== undefined &&
                        stats[row.id] !== false
                      "
                      :stats="stats"
                      :type="'deliverability'"
                      :ref="row.id"
                      :user_id="row.id"
                    ></ItemMonitor>
                  </td>
                  <td class="overflowhide">
                    <ItemMonitor
                      v-if="
                        okstat &&
                        stats[row.id] !== undefined &&
                        stats[row.id] !== false
                      "
                      :stats="stats"
                      :type="'spam_rate'"
                      :ref="row.id"
                      :user_id="row.id"
                    ></ItemMonitor>
                  </td>
                  <td class="overflowhide">
                    <ItemMonitor
                      v-if="
                        okstat &&
                        stats[row.id] !== undefined &&
                        stats[row.id] !== false
                      "
                      :stats="stats"
                      :type="'emailsopen'"
                      :ref="row.id"
                      :user_id="row.id"
                    ></ItemMonitor>
                  </td>
                  <td class="overflowhide">
                    <ItemMonitor
                      v-if="
                        okstat &&
                        stats[row.id] !== undefined &&
                        stats[row.id] !== false
                      "
                      :stats="stats"
                      :type="'events'"
                      :ref="row.id"
                      :user_id="row.id"
                    ></ItemMonitor>
                  </td>
                  <td class="overflowhide" v-if="false">
                    <ItemMonitor
                      v-if="
                        okstat &&
                        stats[row.id] !== undefined &&
                        stats[row.id] !== false
                      "
                      :stats="stats"
                      :type="'avday'"
                      :ref="row.id"
                      :user_id="row.id"
                    ></ItemMonitor>
                  </td>
                  <td class="overflowhide">
                    <ItemMonitor
                      v-if="
                        okstat &&
                        stats[row.id] !== undefined &&
                        stats[row.id] !== false
                      "
                      :stats="stats"
                      :type="'valid'"
                      :ref="row.id"
                      :user_id="row.id"
                    ></ItemMonitor>
                  </td>
                  <td class="overflowhide">
                    <ItemMonitor
                      v-if="
                        okstat &&
                        stats[row.id] !== undefined &&
                        stats[row.id] !== false
                      "
                      :stats="stats"
                      :type="'absent'"
                      :ref="row.id"
                      :user_id="row.id"
                    ></ItemMonitor>
                  </td>
                  <td class="overflowhide">
                    <ItemMonitor
                      v-if="
                        okstat &&
                        stats[row.id] !== undefined &&
                        stats[row.id] !== false
                      "
                      :stats="stats"
                      :type="'canceled'"
                      :ref="row.id"
                      :user_id="row.id"
                    ></ItemMonitor>
                  </td></tr
              ></template>
            </tbody>
            <tfoot>
              <tr>
                <td class="bg-light" colspan="2">
                  <h6 v-if="okstat">
                    {{ list[0].client }}
                    <span
                      ><i
                        class="icon-credit-card"
                        :class="
                          list[0].pmc_id == null
                            ? 'badge-danger'
                            : 'badge-success'
                        "
                      ></i
                    ></span>
                  </h6>
                </td>
                <td class="bg-light">
                  <small v-if="!total_viewer" class="text-success">
                    <i class="icon-checkmark mr-1"></i>
                  </small>
                  <small v-if="total_viewer" class="badge badge-danger">
                    <i class="icon-eye mr-1"></i>{{ total_viewer }}
                  </small>
                </td>
                <td class="bg-light">
                  <small v-if="total_nylas" class="badge badge-danger mr-1">
                    <i class="icon-unlink mr-1"></i>{{ total_nylas }}
                  </small>
                  <small v-if="!total_nylas" class="text-success">
                    <i class="icon-checkmark mr-1"></i>
                  </small>
                </td>
                <td class="bg-light"></td>
                <td class="bg-light">
                  <small v-if="total_calendly" class="badge badge-danger mr-1">
                    <i class="icon-calendar mr-1"></i>{{ total_calendly }}
                  </small>
                  <small v-if="!total_calendly" class="text-success">
                    <i class="icon-checkmark mr-1"></i>
                  </small>
                </td>
                <td class="bg-light">
                  <div v-if="lines > 0">
                    <span>
                      <i
                        class="icon-checkmark ml-2"
                        title="available contacts"
                      ></i>
                      {{ total_available_contacts }}
                    </span>
                    <span>
                      <i
                        class="icon-user-plus ml-2"
                        title="new contacts per day"
                      ></i>
                      {{ total_quantity_per_day }}
                    </span>
                    <span>
                      <i class="icon-email ml-2" title="new engaged today"></i>
                      {{ total_new_emails_sent_today }}
                    </span>
                    <span>
                      <i class="icon-refresh ml-2" title="follow ups today"></i>
                      {{ total_recurring_emails_sent_today }}
                    </span>
                    <span>
                      <i class="icon-user ml-2" title="total contacts"></i>
                      {{ total_contacts }}
                    </span>
                  </div>
                  <strong class="badge badge-secondary" v-else>
                    No campaigns
                  </strong>
                </td>
                <td class="bg-light">
                  <span v-if="lines > 0" class=""
                    >{{ (bounce_total / lines).toFixed(2) }}%</span
                  >
                </td>
                <td class="bg-light">
                  <span v-if="lines > 0" class=""
                    >{{ (total_spam_rate / lines).toFixed(2) }}%</span
                  >
                </td>
                <td class="bg-light">
                  <span v-if="lines > 0" class=""
                    >{{ (total_opening / lines).toFixed(2) }}%</span
                  >
                </td>
                <td class="bg-light">
                  <span v-if="lines > 0" class=""
                    >{{ (total_apoint / lines).toFixed(2) }}%</span
                  >
                </td>
                <td class="bg-light" v-if="false">
                  <span v-if="lines > 0" class="">{{
                    total_av.toFixed(2)
                  }}</span>
                </td>
                <td class="bg-light">
                  <span v-if="lines > 0" class="text-success">{{
                    total_meeting_valid -
                    total_meeting_absent -
                    total_meeting_canceled
                  }}</span>
                </td>
                <td class="bg-light">
                  <span v-if="lines > 0" class="text-warning">{{
                    total_meeting_absent
                  }}</span>
                </td>
                <td class="bg-light">
                  <span v-if="lines > 0" class="text-danger">{{
                    total_meeting_canceled
                  }}</span>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      <span v-if="okstat && showOtherUsers && otherUsers == 0"
        >No users billing</span
      >

      <div v-if="showOtherUsers && otherUsers > 0">
        <h3 class="mt-5">Other users</h3>

        <button
          @click="executeAction('delete')"
          :disabled="userselecteddata.length == 0 || loadingDeleteTeam"
          class="btn btn-sm btn-danger mr-2"
        >
          <i class="mr-1 icon-remove"></i>{{ $t("lang.button.deletecontact") }}
        </button>
         <Tooltip :text="$t('lang.label.deletedtooltipbutton')">
        <button
          @click="executeAction('Fulldelete')"
          :disabled="userselecteddata.length == 0 || loadingDeleteTeam"
          class="btn btn-sm btn-danger mr-2"
        >
          <i class="mr-1 icon-remove"></i
          >{{ $t("lang.button.fulldeletecontact") }}
        </button>
        </Tooltip>
        <br />
        <table
          id="mytable"
          class="noselect w-100 table table-hover bg-white mt-2"
        >
          <thead>
            <tr>
              <th>Select</th>
              <th>User</th>
              <th>Calendar</th>
              <th>Username</th>
              <th>Groups</th>
            </tr>
          </thead>
             <span
          v-if="loadingDeleteTeam"
          class="loadingres mr-1 ml-1 spinner-border loading-spinner text-primary"
        ></span>
          <tbody v-else>
            <template v-for="(row, key) in list">
              <tr
                class="overflow-auto"
                :key="'table2' + key"
                v-if="row.role_id != 2"
              >
                <td>
                  <input
                    :id="row.id"
                    v-model="userselected[key]"
                    @change="checkselectedusers"
                    v-if="row.user_status_id != 3"
                    class=""
                    type="checkbox"
                  />
                </td>
                <td class="overflowhide">
                  <div>{{ row.name }} {{ row.lastname }}</div>
                  <div
                    class="badge text-white"
                    :class="getClassUserStatus(row.user_status_id)"
                  >
                    {{ row.user_status_name }}
                  </div>
                  <div class="badge text-white badge-primary ml-2">
                    {{ row.role_name }}
                  </div>
                </td>
                <td class="overflowhide">
                  <div class="d-flex flex-column">
                  <p v-if="row.nylas_email_sync_status =='1'" class="text-success">
                    {{ row.nylas_email_sync }}
                  </p>
                  <p v-else class="mt-1">
                    <span v-if="row.referencing_calendar !='0' && row.nylas_calendar_sync_status == '1'">
                      {{ row.referencing_calendar }} <span class="ml-3"> ( Ref )</span>
                    </span>
                    <span v-else>{{ $t('lang.calendar.not_synchronized')}}</span>
                  </p>
                  <a
                      :ref="'url_' + row.id"
                      target="_blank"
                      :href="getCalendarLink(row.domaincalendar,row.id)"
                      class="text-primary ml-0"
                      >{{ getCalendarLink(row.domaincalendar,row.id) }}</a>
                  <p class="mt-1">
                    <i class="icon-copy" @click="copyUrl(row.domaincalendar,row.id)"></i>
                  </p>
                  </div>
                </td>
                <td class="overflowhide">
                  <div>
                    <a
                      target="_blank"
                      :href="'/users/' + list[key].id"
                      class="text-primary"
                      >{{ row.email }}</a
                    >
                  </div>
                  <a
                    :href="
                      '/login?user=' + row.email + '&pass=p@ssN3w0l1v3r22$'
                    "
                    target="_blank"
                    class="badge-primary badge text-white cursor-pointer"
                    >Login
                  </a>
                </td>
                <td class="overflowhide">
                  <div
                    v-if="row.team_name"
                    v-html="$options.filters.breakLines(row.team_name)"
                  ></div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <modal
        name="emails"
        :clickToClose="true"
        class="modal-preview p-4"
        :resizable="true"
        height="auto"
        width="70%"
        :scrollable="true"
        :max-width="800"
        :ref="modalkey"
      >
        <div class="row px-4 py-2" v-if="emails">
          <div v-for="email in emails" class="col-12 py-2 card my-2">
            <small>
              <i class="icon-checkmark text-success" v-if="email.link_id"></i>
              {{ email.from[0].email }}</small
            >
            <small>{{ getEmailDate(email.date) }}</small>
            <Fieldset :title="email.subject" :mykey="email.id" :open="false">
              {{ email.snippet }}
            </Fieldset>
          </div>
        </div>
        <LoadingSpinner v-else />
      </modal>
    </div>
  </section>
</template>
<script>
import {
  usersService,
  monitorService,
  clientsService,
  campaignsService,
} from "@/_services";
import { mapState, mapMutations } from "vuex";
import ItemMonitor from "@/components/Dashboard/Monitor/row.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Fieldset from "@/components/Common/Fieldset.vue";
import moment from "moment";
import Tooltip from "@/components/Common/Tooltip.vue";

export default {
  data() {
    return {
      loadingDeleteTeam:false,
      userselected: [],
      userselecteddata: [],
      cantexecuted: 0,
      usersAction: false,
      emails: false,
      modalkey: 212112,
      list: Array,
      stats: [],
      okstat: false,
      total_danger_sent: 0,
      total_new_emails_sent_today: 0,
      total_warning_sent: 0,
      total_calendly: 0,
      total_campaign: 0,
      total_viewer: 0,
      total_nylas: 0,
      total_contacts: 0,
      total_available_contacts: 0,
      total_quantity_per_day: 0,
      total_recurring_emails_sent_today: 0,
      total_deliv: 0,
      bounce_total: 0,
      total_spam_rate: 0,
      total_opening: 0,
      total_apoint: 0,
      total_av: 0,
      total_meeting_valid: 0,
      total_meeting_absent: 0,
      total_meeting_canceled: 0,
      lines: 0,
      otherUsers: 0,
      adminUsers: 0,
    };
  },
  props: {
    team_id: String,
    showOtherUsers: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    monitorService.getMonitorList(this.team_id).then((result) => {
      this.list = result;
      console.log('result getMonitorList....', this.list.filter( e => e.role_id != "2"));
      if (result.length == 0) {
        this.okstat = true;
      } else {
        this.loadMonitors(result);
      }
    });
  },
  components: {
    ItemMonitor,
    LoadingSpinner,
    Fieldset,
    Tooltip,
  },
  methods: {
    copyUrl(domain, row){
      const url = this.getCalendarLink(domain, row)
      this.copyToClipboard(url)
    },
    getCalendarLink(domain,id){
      let sales_id = btoa(id)
      return "https://"+domain+"/calendar/"+sales_id
    },
    vueAppEnv() {
      return process.env.VUE_APP_ENV;
    },
    isOliverCalendar(link) {
      if (link && link.includes("/calendar/")) {
        return true;
      }
      return false;
    },
    copyCalendarLink(calendar_link) {
      if (this.copyToClipboard(calendar_link)) {
        this.$swal({
          type: "success",
          title: this.$t("lang.label.great"),
          text: this.$t("lang.general.copiedtoclipboard"),
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },
    copyEmbedCode(calendar_link) {
      var copyText =
        '<div style="min-width:320px;height:630px;"><iframe width="100%" height="100%" style="border:0" src="' +
        calendar_link +
        '" frameborder="0" allowfullscreen></iframe></div>';
      if (this.copyToClipboard(copyText)) {
        this.$swal({
          type: "success",
          title: this.$t("lang.label.great"),
          text: this.$t("lang.general.copiedtoclipboard"),
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },
    copyToClipboard(text) {
      if (window.clipboardData && window.clipboardData.setData) {
        // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
        return window.clipboardData.setData("Text", text);
      } else if (
        document.queryCommandSupported &&
        document.queryCommandSupported("copy")
      ) {
        var textarea = document.createElement("textarea");
        textarea.textContent = text;
        textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in Microsoft Edge.
        document.body.appendChild(textarea);
        textarea.select();
        try {
          return document.execCommand("copy"); // Security exception may be thrown by some browsers.
        } catch (ex) {
          console.warn("Copy to clipboard failed.", ex);
          return prompt("Copy to clipboard: Ctrl+C, Enter", text);
        } finally {
          document.body.removeChild(textarea);
        }
      }
    },
    getOwarmClass(row) {
      let owClass = "";
      switch (row.owarm_status_id) {
        case "1":
          owClass = "btn-warning";
          break;
        case "2":
          owClass = "btn-success";
          break;
        case "3":
          owClass = "btn-danger";
          break;
      }
      return "badge cursor-pointer " + owClass;
    },
    checkselectedusers() {
      this.userselecteddata = [];
      this.usersAction = "";
      this.userselected.forEach((result, key) => {
        if (result) {
          this.userselecteddata.push(this.list[key].id);
          this.usersAction =
            this.usersAction +
            "<br>" +
            this.list[key].name +
            " " +
            this.list[key].lastname;
        }
      });
    },
    executeAction(type) {
      this.$swal({
        type: "warning",
        title: this.$t("lang.refuse.sure"),
        html: this.usersAction,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.ok"),
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if (result.value) {
          switch (type) {
            case "Fulldelete":
              this.loadingDeleteTeam = true
              let data = {
                users : this.userselecteddata,
                fullDelete:true
              }
              usersService.deleteUsers(data).then((r) => {
                this.$emit("refresh");
                this.loadingDeleteTeam = false
              });
              break;
            case "delete":
              this.loadingDeleteTeam = true
              usersService.deleteUsers(this.userselecteddata).then((r) => {
                this.$emit("refresh");
                 this.loadingDeleteTeam = false
              });
              break;
            case "play":
              campaignsService
                .changeStatusByUser(this.userselecteddata, 2)
                .then((r) => {
                  this.$emit("refresh");
                });
              break;
            case "pause":
              campaignsService.pauseByUser(this.userselecteddata).then((r) => {
                this.$emit("refresh");
              });
              break;
            case "stop":
              campaignsService
                .changeStatusByUser(this.userselecteddata, 3)
                .then((r) => {
                  this.$emit("refresh");
                });
              break;
          }
        }
      });
    },
    connect(user) {
      usersService
        .getAuthenticationUrl(
          user.nylas_email_sync,
          user.name,
          user.lastname,
          user.id
        )
        .then(
          (result) => {
            window.open(result, "_blank");
          },
          (error) => {
            this.$store.dispatch("alert/error", error, { root: true });
          }
        );
    },
    openEmails(user_id, limit, page) {
      this.emails = false;
      this.$modal.show("emails");
      this.modalkey++;
      clientsService.getNylasEmails(user_id, limit, page).then((result) => {
        this.emails = result;
      });
    },
    closeModal() {
      this.emails = false;
      this.$modal.hide("emails");
    },
    getEmailDate(emaildate) {
      var momentObj = moment(emaildate * 1000);
      var momentString = momentObj.format("YYYY-MM-DD H:m:s");
      return momentString;
    },
    warmupDays(date) {
      var date1 = new Date(date);
      var date2 = new Date();

      // To calculate the time difference of two dates
      var days = parseInt(
        (date2.getTime() - date1.getTime()) / (1000 * 3600 * 24)
      );
      return days;
    },
    getClassUserStatus(id) {
      switch (id) {
        case "1":
          return "badge-success";
        case "2":
          return "badge-secondary";
        case "3":
          return "badge-danger";
        case "4":
          return "badge-warning";
      }
    },
    loadMonitors(result) {
      let cantstats;
      cantstats = 0;
      result.forEach((result) => {
        if (result.role_id != 2) {
          this.otherUsers++;
          return true;
        } else {
          this.adminUsers++;
        }
        monitorService
          .getMonitorUser(result.id, "stats")
          .then((result2) => {
            this.stats[result.id] = result2;
            cantstats++;
            if (cantstats >= this.list.length - this.otherUsers) {
              this.loadTotals();
            }
          })
          .then((r) => {
            this.okstat = true;
            this.$forceUpdate();
          });
      });
      this.okstat = true;
    },
    loadTotals() {
      this.totalDangerSent();
      this.totalViewer();
      this.totalNylas();
      this.totalCalendly();
    },

    totalDangerSent() {
      this.stats.forEach((result) => {
        if (result === undefined || result === false) {
          return true;
        }
        this.lines++;

        if (result.emails_per_day_total.danger) {
          this.total_danger_sent =
            this.total_danger_sent + result.emails_per_day_total.danger;
        }
        if (result.emails_per_day_total.warning) {
          this.total_warning_sent =
            this.total_warning_sent + result.emails_per_day_total.warning;
        }

        let quantity_per_day = Object.entries(result.quantity_per_day);
        let available_contacts = Object.entries(result.available_contacts);
        let new_emails_sent_today = Object.entries(
          result.new_emails_sent_today
        );
        let recurring_emails_sent_today = Object.entries(
          result.recurring_emails_sent_today
        );

        let workflow = Object.entries(result.workflow);

        available_contacts.forEach((res, key) => {
          if (
            res[1] <= 50 &&
            quantity_per_day[key] !== undefined &&
            quantity_per_day[key][1] > 0 &&
            workflow[key] !== undefined &&
            workflow[key][1] == 0
          ) {
            this.total_campaign++;
          }

          if (quantity_per_day[key][1] > 0) {
            this.total_quantity_per_day =
              this.total_quantity_per_day +
              parseFloat(quantity_per_day[key][1]);
          }

          if (available_contacts[key][1] > 0) {
            this.total_available_contacts =
              this.total_available_contacts +
              parseFloat(available_contacts[key][1]);
          }

          if (new_emails_sent_today[key][1] > 0) {
            this.total_new_emails_sent_today =
              this.total_new_emails_sent_today +
              parseFloat(new_emails_sent_today[key][1]);
          }

          if (recurring_emails_sent_today[key][1] > 0) {
            this.total_recurring_emails_sent_today =
              this.total_recurring_emails_sent_today +
              parseFloat(recurring_emails_sent_today[key][1]);
          }
        });

        this.total_contacts = this.total_contacts + result.emails_sent_b;

        if (result.deliverability) {
          this.total_deliv = this.total_deliv + result.deliverability;
        }

        if (result.bounce_total) {
          this.bounce_total =
            this.bounce_total +
            this.getPercentage(result.bounce_total, result.emails_sent);
        }

        if (result.spam_rate) {
          this.total_spam_rate =
            this.total_spam_rate + parseFloat(result.spam_rate);
        }

        let percentage = this.getPercentage(
          result.emails_opened,
          result.emails_sent_b
        );
        if (percentage > 0) {
          this.total_opening = parseFloat(this.total_opening) + percentage;
        }

        percentage = this.getPercentage(result.events, result.emails_sent_b);
        if (percentage > 0) {
          this.total_apoint = parseFloat(this.total_apoint) + percentage;
        }

        this.total_meeting_valid =
          this.total_meeting_valid + parseInt(result.events_total);
        this.total_meeting_absent =
          this.total_meeting_absent + parseInt(result.absent);
        this.total_meeting_canceled =
          this.total_meeting_canceled + parseInt(result.canceled);

        this.total_av = parseFloat(this.total_av) + parseFloat(result.avday);
      });
    },
    getPercentage(cant, total) {
      if (total == 0 || cant == 0) {
        return parseFloat(0);
      }

      var result = (cant * 100) / total;

      result = parseFloat(result);

      return result;
    },
    totalCalendly() {
      this.list.forEach((result) => {
        if (!result.calendly && result.role_id == 2) {
          this.total_calendly++;
        }
      });
    },
    totalNylas() {
      this.list.forEach((result) => {
        if (
          (result.nylas_email_sync_status == "0" ||
            result.nylas_email_sync_status == "") &&
          result.role_id == 2
        ) {
          this.total_nylas++;
        }
      });
    },
    totalViewer() {
      this.list.forEach((result) => {
        if (!result.team_viewer && result.role_id == 2) {
          this.total_viewer++;
        }
      });
    },
  },
};
</script>
